import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Property } from 'src/typings';

@Component({
  selector: 'app-new-property-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent {
  @Output() propsSelectedEvent: EventEmitter<{
    property: Property;
    values: string[];
  }> = new EventEmitter();

  @Input() set selectedProps(payload: { property: Property; values: string[] }[] | undefined) {
    this._selectedProps = payload;
  }

  @Input() loading: boolean = false;

  get selectedProps() {
    return this._selectedProps;
  }

  private _selectedProps: { property: Property; values: string[] }[] | undefined;

  @Input() availableProps: { property: Property; values: string[] }[] = [];

  selectedEvent(payload: { property: Property; values: string[] }) {
    this.propsSelectedEvent.emit(payload);
  }

  getSelectedValues(property: Property) {
    const find = this.selectedProps?.find((row) => row.property.id === property.id);
    if (find) {
      return find.values.map((value) => {
        return { value };
      });
    } else {
      return [];
    }
  }
}
